import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Protected Route Component
const ProtectedRoute = ({ children, allowedRoles, requiredCapabilities, requiredActions, adminOnly = false }) => {
  const { currentUser, currentAdmin, userRole, activeRoles, loading, hasCapability, canPerformAction } = useAuth();
  const location = useLocation();

  if (loading) {
    // You could render a loading spinner here
    return <div>Loading...</div>;
  }

  // Super admin has unrestricted access (GodMode) - can access any route
  if (currentAdmin?.role === 'super_admin' || currentUser?.role === 'super_admin') {
    return children;
  }

  // Handle admin-only routes
  if (adminOnly) {
    if (!currentAdmin) {
      return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    return children;
  }

  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check for specific capabilities (new system)
  if (requiredCapabilities && requiredCapabilities.length > 0) {
    const hasRequiredCapabilities = requiredCapabilities.some(capability => 
      hasCapability(capability)
    );
    if (!hasRequiredCapabilities) {
      return <Navigate to="/" replace />;
    }
  }

  // Check for specific actions (new system)
  if (requiredActions && requiredActions.length > 0) {
    const canPerformRequiredActions = requiredActions.some(action => 
      canPerformAction(action)
    );
    if (!canPerformRequiredActions) {
      return <Navigate to="/" replace />;
    }
  }

  // Legacy role-based check (for backward compatibility)
  if (allowedRoles && !allowedRoles.some(role => activeRoles.includes(role))) {
    // Fallback to old userRole check for legacy compatibility
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;